module.exports = __webpack_public_path__ + "img/small-4.a9263d9e.jpg";